import { SellingPlanChangedEventArgs, subscribeToSellingPlanChangedEvent } from '../events/selling-plan-changed'
import { widgetState } from '../store/customizations/index'
import { getSellingPlanGroup } from '../store/selling-plans/getters'
import { Publisher } from './event-bus/event-bus'

export const hooksCustomizatioKeyPrefix = 'hooks-'

export const sellingPlanChangedHookInit = () => {
  subscribeToSellingPlanChangedEvent((publisher: Publisher, args: SellingPlanChangedEventArgs) => {
    const isBuyOnce = args.isBuyOnce // eslint-disable-line no-unused-vars
    const selectedSellingPlanGroup = getSellingPlanGroup(args.selectedGroupId)
    const selectedSellingPlan = selectedSellingPlanGroup && selectedSellingPlanGroup.sellingPlans // eslint-disable-line no-unused-vars
      ? selectedSellingPlanGroup.sellingPlans.find(plan => plan.id.toString() === args.selectedSellingPlanId) // eslint-disable-line no-unused-vars
      : null
    eval(widgetState.customizations.hooks.sellingPlanChanged) // eslint-disable-line no-eval
  })
}

export const fireWidgetReadyHook = () => {
  eval(widgetState.customizations.hooks.widgetReady) // eslint-disable-line no-eval
}
